import { useQuery } from "@apollo/client/react";
import type { ClientModel } from "../../models/ClientModel";
import GET_CLIENT from "../queries/getClient";

export const useClient = (clientIdentifier: string) => {
  const { data, error, loading, refetch } = useQuery<{ client: ClientModel }>(
    GET_CLIENT,
    {
      variables: {
        clientIdentifier: clientIdentifier,
      },
    }
  );
  return { client: data?.client, error, loading, refetch };
};
